const COLOR = {
  BLACK: '#000000',
  WHITE: '#ffffff',
  TRANSPARENT: 'transparent'
}

export {COLOR}